export function setCookie(name: string, value: string, days?: number): void {
    if (typeof document === 'undefined') return;

    let cookie = `${name}=${value}`;

    if (days) {
        const date = new Date();

        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        cookie += `; expires=${date.toUTCString()}`;
    }

    cookie += '; path=/';
    document.cookie = cookie;
}
